// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2dTa2","item":"PaymentsMobile_item__2yZLC","label":"PaymentsMobile_label__1I4Ce","amount":"PaymentsMobile_amount__7kCJe"};